import type { Task } from './types';

export const taskFromRow = (row: any): Task => ({
  id: row.id, teamId: row.team_id ?? undefined, title: row.title,
  ownerId: row.owner_id ?? undefined, dueDate: row.due_date ?? undefined,
  completed: row.completed, completedAt: row.completed_at ?? undefined,
  createdAt: row.created_at ?? undefined,
  issueId: row.issue_id ?? undefined, milestoneId: row.milestone_id ?? undefined,
  delayCount: row.delay_count ?? 0, year: row.year ?? undefined,
  quarter: row.quarter ?? undefined, rockId: row.rock_id ?? undefined,
  status: (row.status ?? (row.completed ? 'done' : 'open')) as Task['status'],
  queuedAction: row.queued_action ?? undefined,
});
